<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-container>
        <v-col>
          <v-row no-gutters align="center">
            <v-btn class="mr-5" icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-col cols="12" md="4" xs="12">
              <h1 class="my-0">{{ city.name }}</h1>
              <h3>{{ schoolsByCity(city.id).length }} escolas</h3>
            </v-col>

            <v-col align-self="center">
              <v-autocomplete
                v-model="school"
                :items="schoolsByCity(city.id)"
                item-text="name"
                return-object
                label="Escolha uma escola"
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <charts v-if="!school.name" :city="city.id" />

          <v-row v-else>
            <v-col>
              <v-row>
                <v-col class="ma-0 py-0" cols="12" xs="12" sm="12" md="12">
                  <h3>IDENTIFICAÇÃO DA ESCOLA</h3>
                </v-col>
                <v-col md="6">
                  <h4>Nome da Escola</h4>
                  {{ school.name.toLocaleUpperCase() }}
                </v-col>
                <v-col md="4">
                  <h4>Endereço</h4>
                  {{ school.address }}
                </v-col>
                <v-col md="2">
                  <h4>Rede</h4>
                  {{ school.type == 0 ? "Estadual" : "Municipal" }}
                </v-col>
                <v-col md="2">
                  <h4>N° de alunos</h4>
                  {{ school.pupilsNumber }}
                </v-col>
                <v-col md="2">
                  <h4>N° de docentes</h4>
                  {{ school.teachersNumber }}
                </v-col>
                <v-col md="3">
                  <h4>N° da Equipe Técnica</h4>
                  {{ school.othersProfissionals }}
                </v-col>
                <v-col md="5">
                  <h4>Modalidades de Ensino</h4>
                  {{ modalities }}
                </v-col>
                <v-col class="ma-0 py-0" cols="12" xs="12" sm="12" md="12">
                  <h3>INFRAESTRUTURA</h3>
                </v-col>
                <v-col md="3">
                  <h4>Salas de aula</h4>
                  {{
                    school.classroomsNumber == 0
                      ? "Até 10"
                      : school.classroomsNumber == 1
                      ? "de 10 a 20"
                      : "Mais de 20"
                  }}
                </v-col>
                <v-col v-if="school.auditorium" md="3">
                  <h4>Capacidade do auditório</h4>
                  {{
                    school.auditoriumCapacity == 0
                      ? "Até 50"
                      : school.auditoriumCapacity == 1
                      ? "de 50 a 100"
                      : "Mais de 100"
                  }}
                  pessoas
                </v-col>
                <v-col v-else md="3">
                  <h4>Não possui auditório</h4>
                </v-col>

                <v-col v-if="school.computersRoom" md="3">
                  <h4>N° de computadores</h4>
                  {{
                    school.computersQty == 0
                      ? "Até 5"
                      : school.computersQty == 1
                      ? "de 5 a 10"
                      : "Mais de 10"
                  }}
                </v-col>
                <v-col v-else md="3">
                  <h4>Não possui computadores</h4>
                </v-col>
                <v-col v-if="school.multimidiaRoom" md="3">
                  <h4>Sala Multimídia</h4>
                  {{ school.multimidiaDescription }}
                </v-col>
                <v-col v-else md="3">
                  <h4>Não possui Sala Multimídia</h4>
                </v-col>
                <v-col>
                  <h4 v-if="school.sportsCourt">Possui Quadra de esportes</h4>
                  <h4 v-else>Não possui Quadra de esportes</h4>
                </v-col>
                <v-col>
                  <h4 v-if="school.library">Possui Biblioteca</h4>
                  <h4 v-else>Não possui Biblioteca</h4>
                </v-col>
                <v-col>
                  <h4 v-if="school.internetAccess">Possui Acesso a Internet</h4>
                  <h4 v-else>Não possui Acesso a Internet</h4>
                </v-col>
                <v-col>
                  <h4 v-if="school.computersAccess">
                    Alunos possuem acesso a computadores em sala de aula
                  </h4>
                  <h4 v-else>
                    Alunos não possuem acesso a computadores em sala de aula
                  </h4>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              v-if="isEvents"
              class="ma-0 py-0"
              cols="12"
              xs="12"
              sm="12"
              md="12"
            >
              <h3>EVENTOS ESCOLARES</h3>
            </v-col>
            <v-col v-if="events" md="2">
              <h4>Eventos</h4>
              {{ events }}
            </v-col>
            <v-col v-else md="2">
              <h4>Não realiza eventos</h4>
            </v-col>
            <v-col v-if="school.calendar">
              {{ school.calendarDescription }}
            </v-col>
            <v-col v-else> Não declarou calendário </v-col>
            <v-col v-if="school.eventsDescription">
              {{ school.eventsDescription }}
            </v-col>
            <v-col v-else> Não descrevou eventos </v-col>
          </v-row>
        </v-col>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { cities } from "@/utils";
import charts from "@/components/charts";
import { mapGetters } from "vuex";
export default {
  components: {
    charts,
  },
  props: ["dialog", "cityId"],
  mounted() {
    this.city = cities.find((obj) => obj.id == this.cityId);
    this.schools = this.$store.getters.schoolsByCity(this.cityId);
  },
  data: () => ({
    school: {},
    city: {
      name: "",
      id: "",
    },
    schools: [],
    search: "",
    selectedSchool: {},
  }),
  methods: {
    setSchool(school) {
      this.selectedSchool = school;
      //   console.log(school);
    },
    clearSearch() {
      this.search = "";
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
  computed: {
    isStats: function () {
      return (
        this.school.auditorium ||
        this.school.multimidiaRoom ||
        this.school.sportsCourt
      );
    },
    isEvents: function () {
      return (
        this.school.calendar ||
        this.school.calendarDescription ||
        this.school.eventsType ||
        this.school.eventsDescription
      );
    },
    events: function () {
      let toReturn = "";

      if (this.school.eventsType == 0) toReturn += "Feira ou clube de ciência";
      if (this.school.eventsType == 1) toReturn += "Robótica";
      if (this.school.eventsType == 2) toReturn += "Olimpíadas de Ciências";
      if (this.school.eventsType == 3) toReturn += "Outros";

      return toReturn;
    },
    modalities: function () {
      let toReturn = "";
      if (this.school.modalities.includes(0)) toReturn += "Ensino Infantil, ";
      if (this.school.modalities.includes(1))
        toReturn += "Ensino Fundamental 1, ";
      if (this.school.modalities.includes(2))
        toReturn += "Ensino Fundamental 2, ";
      if (this.school.modalities.includes(3)) toReturn += "Ensino Médio, ";
      if (this.school.modalities.includes(4)) toReturn += "EJA, ";
      if (this.school.modalities.includes(5))
        toReturn += "Ensino Profissionalizante.";

      if (toReturn.endsWith(", ")) toReturn = toReturn.slice(0, -2);

      return toReturn;
    },
    ...mapGetters(["schoolsByCity"]),
    filteredItems() {
      return this.schools.filter((school) => {
        if (!this.search) return this.schools;
        return school.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
};
</script>